// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedHandTrigger_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 13C18 13.5523 17.5523 14 17 14H9C8.72386 14 8.5 14.2239 8.5 14.5 8.5 14.7761 8.72386 15 9 15H16C16.5523 15 17 15.4477 17 16 17 16.5523 16.5523 17 16 17H9C8.72386 17 8.5 17.2239 8.5 17.5 8.5 17.7761 8.72386 18 9 18H14C14.5523 18 15 18.4477 15 19 15 19.5523 14.5523 20 14 20H9C5.13401 20 2 16.866 2 13 2 9.13401 5.13401 6 9 6H12C12.5523 6 13 6.44772 13 7 13 7.55228 12.5523 8 12 8H9C6.23858 8 4 10.2386 4 13 4 13.2761 4.22386 13.5 4.5 13.5 4.77614 13.5 5 13.2761 5 13 5 10.7909 6.79086 9 9 9H16C16.5523 9 17 9.44772 17 10 17 10.5523 16.5523 11 16 11H9C8.72386 11 8.5 11.2239 8.5 11.5 8.5 11.7761 8.72386 12 9 12H17C17.5523 12 18 12.4477 18 13ZM18 0H20V2H22V4H16V2H18V0Z" class="svg-bg"/>
  <path d="M22 6H16V7C16.8885 7 17.6868 7.38625 18.2361 8H20V18C20 18.5523 19.5523 19 19 19C18.5216 19 18.1216 18.664 18.0232 18.2151C17.7285 18.4845 17.3798 18.6958 16.9953 18.8309C16.9984 18.8869 17 18.9433 17 19C17 19.3698 16.9331 19.724 16.8107 20.0511C17.1358 20.398 17.5424 20.6676 18 20.8293V24H20V20.8293C21.1652 20.4175 22 19.3062 22 18V6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedHandTrigger is a generated icon component.
 */
let IconMedHandTrigger = IconMedHandTrigger_1 = class IconMedHandTrigger extends IconBaseElement {
    render() {
        return html `${IconMedHandTrigger_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedHandTrigger.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedHandTrigger = IconMedHandTrigger_1 = __decorate([
    customElement('zui-icon-med-hand-trigger')
], IconMedHandTrigger);
export { IconMedHandTrigger };
